import React from 'react';
import { Card } from '../../ui/Card';
import { motion } from 'framer-motion';
import { ArrowDownIcon, ArrowUpIcon } from 'lucide-react';
interface SummaryCardProps {
  title: string;
  value: string;
  subtext?: string;
  subtextColor?: 'default' | 'success' | 'warning' | 'error' | 'accent';
  trend?: string;
  trendDirection?: 'up' | 'down' | 'neutral';
  delay?: number;
}
export function SummaryCard({
  title,
  value,
  subtext,
  subtextColor = 'default',
  trend,
  trendDirection,
  delay = 0
}: SummaryCardProps) {
  const getSubtextColor = () => {
    switch (subtextColor) {
      case 'success':
        return 'text-accent-success';
      case 'warning':
        return 'text-yellow-500';
      case 'error':
        return 'text-red-500';
      case 'accent':
        return 'text-accent-primary';
      default:
        return 'text-text-secondary';
    }
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3,
    delay
  }} data-id="element-155">
      <Card className="p-6 h-full flex flex-col justify-between" data-id="element-156">
        <div data-id="element-157">
          <div className="text-text-secondary text-xs uppercase font-bold tracking-wider mb-2" data-id="element-158">
            {title}
          </div>
          <div className="text-3xl font-bold text-white mb-2" data-id="element-159">{value}</div>
        </div>

        <div className={`text-sm flex items-center gap-2 ${getSubtextColor()}`} data-id="element-160">
          {trend && <span className={`flex items-center ${trendDirection === 'up' ? 'text-red-500' : trendDirection === 'down' ? 'text-accent-success' : 'text-text-secondary'}`} data-id="element-161">
              {trendDirection === 'up' && <ArrowUpIcon className="w-4 h-4 mr-1" data-id="element-162" />}
              {trendDirection === 'down' && <ArrowDownIcon className="w-4 h-4 mr-1" data-id="element-163" />}
              {trend}
            </span>}
          {subtext && <span data-id="element-164">{subtext}</span>}
        </div>
      </Card>
    </motion.div>;
}